/* ============================================================
   <DemoCTA />
   ------------------------------------------------------------
   The single source of truth for the "Book walkthrough demo"
   CTA. Renders an anchor tag that opens the Calendly booking
   page in a new tab. Used in:
     - <Nav>            (variant="nav")
     - hero             (variant="primary")
     - per-product CTA  (variant="primary"  source={productId})
     - global CTA band  (variant="primary")
   ============================================================ */

const CALENDLY_URL = 'https://calendly.com/gabriel-openinsurance/30min';

export default function DemoCTA({
  variant = 'primary',          // "primary" | "ghost" | "nav"
  label = 'Book walkthrough demo',
  // `source` is accepted for backwards-compat with existing
  // callsites; the Calendly URL is the same regardless.
  // eslint-disable-next-line no-unused-vars
  source = null,
  showArrow = true,
  className = '',
  ...rest
}) {
  const variantClass = {
    primary: 'btn-primary',
    ghost: 'btn-ghost',
    nav: 'nav-cta',
  }[variant] || 'btn-primary';

  return (
    <a
      href={CALENDLY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${variantClass} ${className}`.trim()}
      {...rest}
    >
      {label}
      {showArrow && (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path
            d="M1 7h12m0 0L8 2m5 5l-5 5"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </a>
  );
}
